import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CallState {
  menuList: [];
}

const initialState: CallState = {
  menuList: [],
};

const myXToneMenu = createSlice({
  name: "menuPermissions", // Use a different name for the slice
  initialState,
  reducers: {
    updateMenu: (state, action: PayloadAction<any>) => {
      state.menuList = action.payload;
      console.log("state.activeMenu", state.menuList);
    },
  },
});
export const { updateMenu } = myXToneMenu.actions;
export default myXToneMenu.reducer;
